import { useState } from 'react';
import cn from 'classnames';

const CheckForm = ({ value, label, name, onChange }) => {
  return (
    <div className="relative flex items-center mr-5 sm:mr-16 cursor-pointer w-105 sm:w-125 group h-30">
      <input
        type="checkbox"
        id={name}
        name={name}
        onChange={onChange}
        className="absolute top-0 left-0 w-full h-30 opacity-0 z-2 cursor-pointer"
        value={value}
      />
      <label
        htmlFor={value}
        className={cn(
          'absolute z-1 top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 c1 block rounded-full text-cyan-dark cursor-pointer uppercase whitespace-nowrap duration-30',
          { 'text-white': value }
        )}
      >
        {label}
      </label>
      <svg
        className="w-105 sm:w-125 h-auto absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 pointer-events-none"
        width="125"
        height="34"
        viewBox="0 0 125 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.35"
          y="0.35"
          width="124.3"
          height="33.3"
          rx="16.65"
          stroke="#064246"
          strokeWidth="0.7"
        />
      </svg>
      <svg
        className="w-105 sm:w-125 h-auto absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 opacity-0 group-hover:opacity-100 duration-30 pointer-events-none"
        viewBox="0 0 125 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.35"
          y="0.35"
          width="124.3"
          height="33.3"
          rx="16.65"
          stroke="url(#paint0_linear_4002_10602)"
          strokeWidth="0.7"
        />
        <defs>
          <linearGradient
            id="paint0_linear_4002_10602"
            x1="141.452"
            y1="0"
            x2="-4.16667"
            y2="0"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#EE4424" />
            <stop offset="0.468331" stopColor="#FD813E" />
            <stop offset="1" stopColor="#22CDC6" />
          </linearGradient>
        </defs>
      </svg>
      <svg
        className={cn(
          'w-105 sm:w-125 h-auto absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 opacity-0 duration-30 pointer-events-none',
          {
            '!opacity-100': value
          }
        )}
        viewBox="0 0 125 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.35"
          y="0.35"
          width="124.3"
          height="33.3"
          rx="16.65"
          fill="url(#paint0_linear_4002_10603)"
        />
        <rect
          x="0.35"
          y="0.35"
          width="124.3"
          height="33.3"
          rx="16.65"
          stroke="url(#paint1_linear_4002_10603)"
          strokeWidth="0.7"
        />
        <defs>
          <linearGradient
            id="paint0_linear_4002_10603"
            x1="125"
            y1="0"
            x2="-4.16667"
            y2="0"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#EE4424" />
            <stop offset="1" stopColor="#FD813E" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_4002_10603"
            x1="125"
            y1="0"
            x2="-4.16667"
            y2="0"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#EE4424" />
            <stop offset="1" stopColor="#FD813E" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};
export default CheckForm;
